import { MobileCommExAppControlDriver } from "../MobileCommExAppControlDriver";
import { MobileCommExAppControlLoad } from "../MobileCommExAppControlLoad";
import { MobileCommExAppControlMessage } from "../MobileCommExAppControlMessage";
import { MobileCommExAppControlSendLoad } from "../MobileCommExAppControlSendLoad";
import { MobileCommExAppControlTractor } from "../MobileCommExAppControlTractor";
import { MobileCommExAppControlTrailerTracking } from "../MobileCommExAppControlTrailerTracking";
import { MobileCommExAppSelectionList } from "../MobileCommExAppSelectionList";
import { Button, DataHeader, DataSource, HorizontalSpacer, Label, Layout, Panel, Splitter, Tab, Table, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutMobileCommExAppControl extends Layout {
    buttonExpandSelections: Button;
    dataheaderMobileCommExAppControl: DataHeader;
    horizontalspacer1: HorizontalSpacer;
    labelTotalCharge: Label;
    layoutMobileCommControlDriver: MobileCommExAppControlDriver;
    layoutMobileCommControlLoad: MobileCommExAppControlLoad;
    layoutMobileCommControlMessage: MobileCommExAppControlMessage;
    layoutMobileCommControlSendLoad: MobileCommExAppControlSendLoad;
    layoutMobileCommControlTractor: MobileCommExAppControlTractor;
    layoutMobileCommControlTrailerTracking: MobileCommExAppControlTrailerTracking;
    layoutMobileCommExAppSelectionList: MobileCommExAppSelectionList;
    panelCollapseForm: Panel;
    panelForm: Panel;
    sourceMCExAppControl: DataSource;
    sourceMobileCommFormFieldOpt: DataSource;
    splitterMain: Splitter;
    tabDriver: Tab;
    tabLTL: Tab;
    tabLoad: Tab;
    tabMessage: Tab;
    tabSelections: Tab;
    tabSendLoad: Tab;
    tabTractor: Tab;
    tabTrailerTracking: Tab;
    tableFormFieldOpt: Table;
    tabsetMobileCommControl: Tabset;
    textboxDistanceRadius: Textbox;
    textboxMcControlId: Textbox;
    textboxMcFormid: Textbox;
}
